import {ToastProps} from "../../BaseProps";
import {useDocument} from "hooks/index";
import {NewAccessListMemberItemType} from "types/ActivityFeedTypes";
import {doc} from "firebase/firestore";
import {userActivityFeedPath} from "../../utility";
import {SkeletonItem} from "components/index";
import BaseItem from "./BaseItem";
import SystemIndex from "assets/icons/system/system.index";
import IconBaseProps from "./IconBaseProps";
import {enActivityFeedLabel} from "constants/index";
import {getActivityName} from "components/ActivityFeed/utils";

interface NewAccessListMemberItemprops extends ToastProps {
  itemId: string;
  uid: string;
  index: number;
  updatePinnedValue: (index: number, pinned: boolean) => void;
}

function NewAccessListMemberItem(props: NewAccessListMemberItemprops) {
  const {toastProps, itemId, uid, updatePinnedValue, index} = props;

  const [activityFeed] = useDocument<NewAccessListMemberItemType>(doc(userActivityFeedPath(uid), itemId));

  if (!activityFeed) {
    return <SkeletonItem height={"5rem"} sx={{marginTop: "5px", width: "80%"}}/>
  }

  const {details} = activityFeed;
  const {by, name} = details;

  return <BaseItem
    index={index}
    uid={uid}
    item={activityFeed}
    icon={<SystemIndex.SystemIcons.ArrowRight {...IconBaseProps}/>}
    text={enActivityFeedLabel.assigned(name, by.name ?? "", getActivityName(activityFeed))}
    toastProps={toastProps}
    updatePinnedValue={updatePinnedValue}
  />
}

export default NewAccessListMemberItem;